<template>
  <div class="helpCenter">
    <div class="top-nav-bar">
      <van-navBar :title="title" @click-left="$router.back()">
        <i class="icon back-arrow" slot="left"></i>
      </van-navBar>
    </div>
    <div class="content rich-text" v-html="content"></div>
  </div>
</template>

<script>
import { NavBar } from 'vant';
export default {
  name: 'HelpCenter',
  components: { 'van-navBar': NavBar },
  data () {
    return {
      title: '',
      content: ''
    };
  },
  watch: {
    $route: {
      handler ({ name, params: { type } }) {
        if (name === 'HelpCenter') {
          this.entryPage(type);
        }
      },
      immediate: true
    }
  },
  methods: {
    entryPage (type) {
      // 1.帮助中心 2.免责声明 3.服务协议 4.保护协议 5.关于我们
      const titles = ['', '帮助中心', '免责声明', '用户服务协议', '用户注册协议', '保护协议', '关于我们', '购买须知', '', '隐私政策'];
      this.title = titles[type];
      this.$route.meta.title = this.title;
      const urls = [
        '',
        'agreement?type=7',
        'agreement?type=5',
        'agreement?type=1',
        'agreement?type=1',
        'agreement?type=8',
        'agreement?type=3',
        'agreement?type=9',
        '',
        'agreement?type=9'
      ];
      this.$http.get(urls[type], { showLoading: true }).then((res) => {
        this.content = res.data.content || '';
      });
    }
  }
};
</script>

<style lang="less" scoped>
.helpCenter {
  .top-nav-bar {
    flex-shrink: 0;
    width: 100%;
    height: 94px;

    /deep/.van-nav-bar {
      position: fixed;
      top: 0;
      right: 0;
      left: 0;
      z-index: 999;
      width: 100%;
      height: 94px;
      margin: auto;
      background-color: #fff;

      &::after {
        border: none;
      }

      .van-nav-bar__title {
        font-size: 34px;
        font-weight: bold;
        line-height: 94px;
        color: #222;
        color: #1a1a1a;
      }

      .van-nav-bar__left {
        left: 0;
      }

      .van-nav-bar__right {
        right: 0;
      }

      .van-nav-bar__left,
      .van-nav-bar__right {
        z-index: 999;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 94px;
        padding: 0 30px;
      }

      .back-arrow {
        width: 32px;
        height: 32px;
        background-image: url("~@/assets/images/icon_backArrow_01.png");
        background-size: contain;
      }
    }
  }
  .content {
    padding: 0 20px;
    font-size: 24px;
  }
}
</style>